import { useState, useEffect } from "react";
import { v4 as uuidv4 } from "uuid";
import { useSelector } from "react-redux";
import {studiotracelog} from 'utils/envsetup';
const useEventLogging = () => {
  const [response, setResponse] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [controller, setController] = useState();


  // const tenantId = useSelector((state) => state.commonData?.tenant?.tenantId);
  // const applicationName = useSelector((state) => state.workSpace?.selectedAppName);
  // const userId = useSelector((state) => state.commonData?.userProfile?.userId);
  // const sessionId = useSelector((state) => state.commonData?.userProfile?.sessionId);
  // const applicationId = useSelector((state) => state.commonData?.applicationId);


  const axiosEventLog = async (configObj) => {
    const { axiosInstance ,level, msg ,eventName , module} = configObj;
    try {
      // const requestId = uuidv4(); // Generate a unique ID for each request
    
      // const requestConfig = [
      //   {
      //     tenantId,
      //     applicationId,
      //     applicationName,
      //     userId,
      //     sessionId,
      //     requestId,
      //     level,
      //     module,
      //     events: [
      //       {
      //         eventName: eventName,
      //         message: msg,
      //       },
      //     ],
      //   },
      // ];
    
      setLoading(true);
      const ctrl = new AbortController();
      setController(ctrl);
      // const res = await axiosInstance.post(studiotracelog, requestConfig, {
      //   signal: ctrl.signal,
      // });

      // setResponse(res.data);
      // return res.data;
    } catch (err) {
      setError(err.message);
     // console.log("useEventLogging Error:", err.code);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    return () => controller && controller.abort();
  }, [controller]);

  return [response, error, loading, axiosEventLog];
};

export default useEventLogging;
